export default {
      id: "copy-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#copy",
      toString: function () {
        return this.url;
      }
    }